import billingService from '@/_legacy/services/billing';
import subscriptionService from '@/_legacy/services/subscription';
import { user } from '@/ui/auth/auth';

function getDefaultState() {
  return {
    nextProduct: {},
    product: {},
    selectedPlan: {},
    invoices: {},
    subscription: user.value._legacy_subscription ? user.value._legacy_subscription : {},
  };
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    nextProduct: state => state.nextProduct,
    product: state => state.product,
    selectedPlan: state => state.selectedPlan,
    subscription: state => state.subscription,
    invoices: state => state.invoices,
  },
  mutations: {
    setNextProduct(state, product) {
      state.nextProduct = product;
    },
    setProduct(state, product) {
      state.product = product;
    },
    setSelectedPlan(state, selectedPlan) {
      state.selectedPlan = selectedPlan;
    },
    setSubscription(state, subscription) {
      state.subscription = subscription;
    },
    setInvoices(state, invoices) {
      state.invoices = invoices;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async fetchPlan({ commit }, { slug, interval }) {
      return billingService.getPlan(slug, interval);
    },

    async getPlan({ commit, dispatch }, { slug, interval }) {
      await dispatch('fetchPlan', { slug, interval })
        .then(({ product, selected_plan: selectedPlan }) => {
          commit('setProduct', product);
          commit('setSelectedPlan', selectedPlan);
        });
    },

    async getSubscription({ commit }) {
      await subscriptionService.getSubscription()
        .then(({ data: subscription }) => {
          commit('setSubscription', subscription);
        })
        .catch(() => {
        });
    },

    async getInvoices({ commit }, limit = null) {
      await subscriptionService.getInvoices(limit)
        .then(({ data: invoices }) => {
          commit('setInvoices', invoices);
        });
    },
  },
};
